// components/BackgroundMusic.js
import { useEffect, useRef } from "react";

const BackgroundMusic = ({ isMuted, isActive = false }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = new Audio();
    audio.preload = "none";
    audio.loop = true;
    audio.volume = 0.4;
    audioRef.current = audio;

    return () => {
      audio.pause();
      audio.removeAttribute("src");
    };
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.muted = isMuted;
    }
  }, [isMuted]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    if (!isActive) {
      audio.pause();
      return;
    }

    if (!audio.src) {
      audio.src = "/sounds/chronologiclesoundtrack.mp3";
    }
    audio.play().catch(() => {});
  }, [isActive]);

  return null;
};

export default BackgroundMusic;
